import { Component, inject } from '@angular/core';
import { DialogComponent } from '../../components/dialog/dialog.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NewActionButtonComponent } from '../../components/new-action-button/new-action-button.component';
import { FormsModule } from '@angular/forms';
import { of, switchMap } from 'rxjs';
import { DialogPayload } from 'src/services/dialog.service';
import { TaskService } from 'src/services/task.service';
import { TaskSetService } from 'src/services/task-set.service';

export interface DeleteTaskDialogPayload {
  postDeleteCallback: () => void;
  id: number;
  isTaskSet?: boolean;
}

@Component({
  selector: 'app-delete-task-dialog',
  imports: [DialogComponent, NewActionButtonComponent, FormsModule],
  templateUrl: './delete-task-dialog.component.html',
  styleUrl: './delete-task-dialog.component.scss',
})
export class DeleteTaskDialogComponent {
  protected readonly taskSetService = inject(TaskSetService);
  protected readonly taskService = inject(TaskService);
  protected readonly dialogRef = inject(MatDialogRef<DeleteTaskDialogComponent>);
  protected readonly data = inject<DialogPayload<DeleteTaskDialogPayload>>(MAT_DIALOG_DATA);
  protected reason = '';
  protected deleteTask = () => {
    if (!this.reason) return;
    of(null)
      .pipe(
        switchMap(() =>
          this.data.payload.isTaskSet
            ? this.taskSetService.deleteTaskSet(this.data.payload.id, this.reason)
            : this.taskService.deleteTask(this.data.payload!.id, this.reason),
        ),
      )
      .subscribe(() => {
        this.data.payload!.postDeleteCallback();
        this.dialogRef.close();
      });
  };
}
